function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", {
  id: "genericDefs"
});

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M283.9219 271.9688 Q262.8281 310.0781 225.1406 330.1875 Q189.1406 349.4531 144.1406 349.4531 Q99 349.4531 63.1406 330.1875 Q25.4531 310.0781 4.0781 271.9688 Q25.5938 233.7188 63 213.6094 Q98.8594 194.3438 144.1406 194.3438 Q189.2812 194.3438 225.1406 213.6094 Q262.8281 233.7188 283.9219 271.9688 ZM257.3438 271.9688 Q229.7812 223.5938 170.4375 213.75 Q188.1562 221.3438 198.7031 237.0234 Q209.25 252.7031 209.25 271.9688 Q209.25 290.8125 198.8438 306.5625 Q188.4375 322.3125 171.1406 330.0469 Q230.0625 320.0625 257.3438 271.9688 ZM195.75 271.9688 Q195.75 250.7344 180.4922 236.0391 Q165.2344 221.3438 144 221.3438 Q132.8906 221.3438 122.625 225.9844 L117.2812 213.75 Q58.0781 223.875 30.6562 271.9688 Q57.9375 319.9219 116.7188 330.0469 Q99.4219 322.3125 89.0859 306.5625 Q78.75 290.8125 78.75 271.9688 Q78.75 260.4375 82.8281 249.4688 L95.9062 253.5469 Q92.25 262.6875 92.25 271.9688 Q92.25 293.2031 107.4375 307.8984 Q122.625 322.5938 144 322.5938 Q165.375 322.5938 180.5625 307.8984 Q195.75 293.2031 195.75 271.9688 ZM183.0938 271.9688 Q183.0938 288 171.5625 299.1797 Q160.0312 310.3594 144 310.3594 Q127.8281 310.3594 116.3672 299.1797 Q104.9062 288 104.9062 271.9688 Q104.9062 264.7969 107.2969 258.4688 L147.2344 276.6094 L128.5312 236.9531 Q136.125 233.5781 144 233.5781 Q160.0312 233.5781 171.5625 244.7578 Q183.0938 255.9375 183.0938 271.9688 Z",
  stroke: "none"
})));

var SvgEye = function SvgEye(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    fillOpacity: 1,
    colorRendering: "auto",
    colorInterpolation: "auto",
    textRendering: "auto",
    stroke: "black",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    shapeRendering: "auto",
    strokeOpacity: 1,
    fill: "black",
    strokeDasharray: "none",
    fontWeight: "normal",
    strokeWidth: 1,
    fontFamily: "'Dialog'",
    fontStyle: "normal",
    strokeLinejoin: "miter",
    fontSize: 12,
    strokeDashoffset: 0,
    imageRendering: "auto",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgEye, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/eye.ce82362e.svg";
export { ForwardRef as ReactComponent };